import WeeklyEarnings from '@/views/weekly_earnings/WeeklyEarnings.vue';
import { authenticated } from './guards/authGuards';
import { authorized } from './guards/authorizationGuards';
import { go } from './guards/helpers';
import Policies from '@/core/policies';

export default [
  {
    path: '/weekly-earnings',
    component: WeeklyEarnings,
    children: [
      {
        path: 'seller',
        name: 'WeeklyEarningsSeller',
        meta: { role: 'Seller' },
      },
    ],
    beforeEnter: (to, from, next) =>
      next(
        authenticated() ||
          authorized(Policies.WeeklyEarningsPolicy.canView()) ||
          go()
      ),
  },
];
